import { Icon } from "../Components/UI/Icon";
import { useTranslation } from 'react-i18next';

export default function Footer() {
    // Footer commentato per frontend_smb
    return null;
}
